export const ELECTRONIC_KEY_PERIOD_OPTIONS = [
  {
    value: '15min',
    label: '15 minutes',
  },
  {
    value: 'unlimited',
    label: 'Unlimited',
  },
];
